import { useSearchParams, useNavigate } from "react-router-dom";
import ProofContainer from "../../containers/proof";

const ProofPage = () => {
  const [searchParams] = useSearchParams();
  const proof_id = searchParams.get("proof_id");
   const navigate = useNavigate();

  return <ProofContainer proof_id={proof_id} navigate={navigate} />;
};

export default ProofPage;